export class PatientStatus {
  static Admitted = 'Admitted';
  static InWard = 'InWard';
  static InTheatreWaiting = 'InTheatreWaiting';
  static InTheatreOperatingRoom = 'InTheatreOperatingRoom';
  static InTheatreRecovery = 'InTheatreRecovery';
  static Discharged = 'Discharged';
  static TheatreVisitCompletePendingSubmission = 'TheatreVisitCompletePendingSubmission';
  static ProcedureInProgress = 'ProcedureInProgress';

  static isInTheatre(patientStatus: PatientStatus) {
    return (
      patientStatus === this.InTheatreWaiting || patientStatus === this.InTheatreOperatingRoom || patientStatus === this.InTheatreRecovery || patientStatus === this.TheatreVisitCompletePendingSubmission
    );
  }

  static isInTheatreRecovery(patientStatus: PatientStatus) {
    return patientStatus === this.InTheatreRecovery;
  }

  static isPendingSubmit(patientStatus: PatientStatus) {
    return patientStatus === this.TheatreVisitCompletePendingSubmission;
  }
}
